import { SORT_DIRECTION } from '../../../knock-design-system';

export const DRAWER_MODES = {
  CLONE: 'clone',
  FILTER: 'filter',
  MANAGE: 'manage',
};

export const DRAWER_TITLES = {
  [DRAWER_MODES.CLONE]: 'Clone Property Settings',
  [DRAWER_MODES.FILTER]: 'Show/Hide Channels',
  [DRAWER_MODES.MANAGE]: 'Manage Channels',
};

export const PAGINATION_DEFAULTS = {
  ROWS_PER_PAGE: 50,
  ROWS_PER_PAGE_OPTIONS: [25, 50, 100, 500],
  SORT_COLUMN: 'property',
  SORT_DIRECTION: SORT_DIRECTION.ASC,
};

export const DEFAULT_QUERY = {
  page: 0,
  rowsPerPage: PAGINATION_DEFAULTS.ROWS_PER_PAGE,
  sortColumn: PAGINATION_DEFAULTS.SORT_COLUMN,
  sortDirection: SORT_DIRECTION.ASC,
};
